import { client, clientWithoutErrorHandling } from '../http';

export default {
  async createSubscription(token, card) {
    const response = await clientWithoutErrorHandling.post('/api/subscribe', { token, card });
    return response.data;
  },

  async updateCreditCard(token, card) {
    const response = await clientWithoutErrorHandling.post('/api/update-credit-card', { token, card });
    return response.data;
  },

  async getCreditCardDetails() {
    const response = await client.get('/api/credit-card-details');
    return response.data;
  },

  async getSubscription() {
    const response = await clientWithoutErrorHandling.get('/api/latest-subscription');
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/api/BillyApi.js